import { mix } from 'polished';
import styled, { css } from 'styled-components';

import { ITheme } from 'shared/presentation/contexts';

export const Container = styled.ul`
  display: flex;
`;

type TStepColors = {
  background: string;
  font: string;
  border: string;
  label: string;
};

const STATUS_COLORS = (theme: ITheme) => ({
  INACTIVE: {
    background: theme.palette.neutral[50],
    font: theme.palette.neutral[600],
    border: theme.palette.neutral[600],
    label: theme.palette.neutral[600],
  } as TStepColors,
  ACTIVE: {
    background: mix(0.9, theme.palette.neutral[50], theme.palette.primary.main),
    font: theme.palette.text.main,
    border: theme.palette.primary.main,
    label: theme.palette.primary.main,
  } as TStepColors,
  COMPLETE: {
    background: theme.palette.primary.main,
    font: theme.palette.text.white,
    border: theme.palette.primary.main,
    label: theme.palette.text.main,
  } as TStepColors,
});

interface IStepProps {
  status?: keyof ReturnType<typeof STATUS_COLORS>;
  isLast?: boolean;
  height: number;
}

const STEP_WIDTH = 15;
const CIRCLE_SIZE = 4;

export const Step = styled.li<IStepProps>`
  ${({ theme, status = 'INACTIVE', isLast, height }) => {
    const colorsDictionary = STATUS_COLORS(theme);
    const colors = colorsDictionary[status];

    return css`
      display: flex;
      align-items: flex-start;

      pointer-events: none;

      position: relative;

      font-weight: ${theme.typography.weight.bold};

      height: ${theme.layout.spacing(height)};

      width: ${theme.layout.spacing(STEP_WIDTH)};

      section {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: ${theme.layout.spacing(1)};

        width: ${theme.layout.spacing(STEP_WIDTH)};
        top: 0;

        div {
          background-color: ${colors.background};
          border: 2px solid ${colors.border};
          color: ${colors.font};

          font-size: ${theme.typography.sizes.body1};

          height: ${theme.layout.spacing(CIRCLE_SIZE)};
          width: ${theme.layout.spacing(CIRCLE_SIZE)};

          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;

          transition: all 0.2s;
        }

        span {
          color: ${colors.label};
          font-size: ${theme.typography.sizes.body2};

          display: flex;
          align-items: center;
          text-align: center;
        }
      }

      hr {
        border: 1px solid ${colors.border};
        flex: 1;
        display: none;

        transition: all 0.2s ease-out;
        margin-top: ${theme.layout.spacing(CIRCLE_SIZE / 2)};
        margin-left: ${theme.layout.spacing(STEP_WIDTH / 2)};
      }

      ${!isLast &&
      css`
        flex: 1;
        width: auto;

        hr {
          display: block;

          margin-right: -${theme.layout.spacing(STEP_WIDTH / 2)};
        }
      `}
    `;
  }}
`;
